import { IsNotEmpty, IsOptional, IsString, Length, IsEmail, ArrayNotEmpty } from 'class-validator';

export class ProviderInfoDto {

	@Length(1, 100)
	@IsNotEmpty({ message: 'Full name is required' })
	fullName: string;

	@ArrayNotEmpty({ message: 'Target languages are required' })
	targetLanguage: string[];

	@IsNotEmpty({ message: 'Verification type is required' })
	verificationType: boolean;

	@IsNotEmpty({ message: 'Work Status is required' })
	workStatus: string;

	@IsNotEmpty({ message: 'Service type is required' })
	serviceType: string;

	@IsNotEmpty({ message: 'Email is required' })
	@IsEmail()
	email: string;

	districtId: string;

	@IsOptional()
	imageUrl?: string;

	@IsOptional()
	totalEngagements?: number;
}
